import {
  jb_button_back_css_default
} from "./chunk.LUPTECOB.js";
import {
  Rt
} from "./chunk.DS2KVX5X.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  n
} from "./chunk.QXWAL3TN.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-button-back/jb-button-back.ts
var JbButtonBack = class extends r {
  render() {
    return ke`
      <span class="${Rt({ white: this.isWhite })}">
        <jb-arrow-back-icon></jb-arrow-back-icon>
        <span>${this.text}</span>
      </span>
    `;
  }
};
JbButtonBack.styles = [reset_css_default, jb_button_back_css_default];
__decorateClass([
  n({ type: Boolean })
], JbButtonBack.prototype, "isWhite", 2);
__decorateClass([
  n()
], JbButtonBack.prototype, "text", 2);
JbButtonBack = __decorateClass([
  customElement("jb-button-back")
], JbButtonBack);

export {
  JbButtonBack
};
